import React from 'react';
import { useTranslation } from "react-i18next";

/**
 * Pagination Component
 * Displays page navigation controls with stable width
 */
export default function Pagination({
  currentPage,
  totalPages,
  pageNumbers,
  onPageChange,
  onNext,
  onPrevious,
}) {
  const { t } = useTranslation();

  if (totalPages <= 1) return null;

  return (
    <div className="admin-pagination-bottom">
      <button
        className="admin-pagination-btn"
        disabled={currentPage === 1}
        onClick={onPrevious}
      >
        {t("admin.common.prev")}
      </button>

      {pageNumbers.map((page, idx) =>
        page === "..." ? (
          <span key={`ellipsis-${idx}`} className="admin-pagination-ellipsis">
            …
          </span>
        ) : (
          <button
            key={page}
            className={`admin-pagination-number ${
              currentPage === page ? "active" : ""
            }`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        )
      )}

      <button
        className="admin-pagination-btn"
        disabled={currentPage === totalPages}
        onClick={onNext}
      >
        {t("admin.common.next")}
      </button>
    </div>
  );
}
